import { differenceInSeconds } from 'date-fns'

import { RegisterFields, SignUpScenario } from '~/types/sign-up'
import { IUser } from '~/types/user-info-types'

export function getUserAge(user?: IUser | null): number | undefined {
  if (!user) return
  return user.birthYear ? new Date().getFullYear() - Number(user.birthYear) : undefined
}

export function getLoggedInSeconds(user: IUser): number | undefined {
  const loggedInAt = user.loggedInAt

  return differenceInSeconds(new Date(), new Date(loggedInAt))
}

// TODO: deprecated, use user redux slice and remove following
export function userHasAllRequiredFields(user: IUser | null): boolean {
  return Boolean(
    user && (user.facebookEmail || user.email || user.authEmail) && user.country && user.birthYear && user.nickname,
  )
}
export function isBookingCheckoutScenario(scenario: SignUpScenario): boolean {
  return scenario === SignUpScenario.CHECKOUT_FOR_SELF || scenario === SignUpScenario.CHECKOUT_FOR_OTHER
}

export function isCheckoutScenario(scenario: SignUpScenario): boolean {
  return scenario === SignUpScenario.SUBSCRIPTION || isBookingCheckoutScenario(scenario)
}

export function prependCountryCallingCodeToInput(callingCode: string, phoneNumber: string | null | undefined): string {
  return `${callingCode} ${phoneNumber ?? ''}`
}

export function isValidRegisterRequest(
  fields: Partial<Record<keyof RegisterFields, unknown>>,
  scenario?: SignUpScenario,
): fields is RegisterFields {
  return (
    (typeof fields.country === 'string' || scenario === SignUpScenario.SUBSCRIPTION) &&
    typeof fields.wantsNewsletter === 'boolean'
  )
}
